import React from "react";
import "../Style/SubmitArea.scss";

const SubmitArea = () => {
  return (
    <section className="submit">
      <h1 className="sub-title">
        WANT TO WORK WITH US <span className="span">?</span>
      </h1>
      <div className="submit-container">
        <div className="submit-form row">
          <div className="form-field col-lg-6">
            <input id="name" className="input-text" type="text" name="" />
            <label htmlFor="name" className="label">
              Name
            </label>
          </div>
          <div className="form-field col-lg-6">
            <input id="email" className="input-text" type="email" name="" />
            <label htmlFor="email" className="label">
              E-mail
            </label>
          </div>
          <div className="form-field col-lg-6">
            <input id="interested" className="input-text" type="text" name="" />
            <label htmlFor="interested" className="label">
              Interested
            </label>
          </div>
          <div className="form-field col-lg-6">
            <input
              id="your budget"
              className="input-text"
              type="text"
              name=""
            />
            <label htmlFor="your-budget" className="label">
              Your Budget
            </label>
          </div>
          <div className="form-field col-lg-6">
            <input id="subject" className="input-text" type="text" name="" />
            <label htmlFor="subject" className="label">
              Subject
            </label>
          </div>
          <div className="form-field col-lg-6">
            <input id="phone" className="input-text" type="text" name="" />
            <label htmlFor="phone" className="label">
              Phone
            </label>
          </div>
          <div className="form-field col-lg-12">
            <input id="message" className="input-text" type="text" name="" />
            <label htmlFor="message" className="label">
              Message
            </label>
          </div>
          <div className="form-field btn col-lg-12">
              
            <input
              className="submit-btn"
              type="Submit"
              value="submit"
              name=""
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SubmitArea;
